// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__1cKEz","description":"PatientConsentPreview_description__1LZWc"};